import React from 'react';

import {
	differenceInMinutes,
	differenceInHours,
	differenceInDays,
	differenceInMonths,
} from 'date-fns';
import { FormattedRelativeTime } from 'react-intl';

type TimeUnit = 'year' | 'quarter' | 'month' | 'week' | 'day' | 'hour' | 'minute' | 'second';
const getRelativeFormat = (date: Date): { value: number; unit: TimeUnit } => {
	const now = new Date();

	const days = differenceInDays(date, now);
	if (Math.abs(days) >= 30) {
		return { value: differenceInMonths(date, now), unit: 'month' };
	}
	if (Math.abs(days) >= 1) {
		return { value: days, unit: 'day' };
	}

	const hours = differenceInHours(date, now);
	if (Math.abs(hours) >= 1) {
		return { value: hours, unit: 'hour' };
	}

	return { value: differenceInMinutes(date, now), unit: 'minute' };
};

const RelativeDateLabel = ({ timestamp }: { timestamp: string }): JSX.Element => {
	const date = new Date(timestamp);
	const { value, unit } = getRelativeFormat(date);

	return <FormattedRelativeTime value={value} unit={unit} numeric="always" />;
};

export default RelativeDateLabel;
